import { z } from 'zod';
import { CONSTRAINT_KINDS, TABLE_SHAPES } from '../constants.js';
import { auditFields, shortText, ulidSchema } from '../common.js';

export const tableSchema = z.object({
  type: z.literal('Table'),
  wedId: ulidSchema,
  tableId: ulidSchema,
  name: shortText,
  shape: z.enum(TABLE_SHAPES).default('round'),
  capacity: z.number().int().min(1).max(40),
  /** Floor-plan position in abstract units; the canvas maps them to pixels. */
  x: z.number().min(-10000).max(10000).default(0),
  y: z.number().min(-10000).max(10000).default(0),
  rotation: z.number().min(0).max(359).default(0),
  ...auditFields,
});
export type Table = z.infer<typeof tableSchema>;

export const createTableSchema = tableSchema
  .omit({
    type: true,
    wedId: true,
    tableId: true,
    createdAt: true,
    updatedAt: true,
    updatedBy: true,
  })
  .partial()
  .required({ name: true, capacity: true });
export const updateTableSchema = createTableSchema.partial();

export const seatingConstraintSchema = z.object({
  type: z.literal('SeatingConstraint'),
  wedId: ulidSchema,
  constraintId: ulidSchema,
  kind: z.enum(CONSTRAINT_KINDS),
  guestIds: z.array(ulidSchema).min(2).max(20),
  ...auditFields,
});
export type SeatingConstraint = z.infer<typeof seatingConstraintSchema>;

export const createConstraintSchema = seatingConstraintSchema.pick({ kind: true, guestIds: true });

/** Bulk assignment — one write per guest, applied transactionally in batches of 25. */
export const seatingAssignmentSchema = z.object({
  assignments: z
    .array(
      z.object({
        guestId: ulidSchema,
        tableId: ulidSchema.nullable(),
        seat: z.number().int().min(0).max(99).optional(),
      }),
    )
    .max(500),
});
export type SeatingAssignmentInput = z.infer<typeof seatingAssignmentSchema>;
